


import React from "react";
import "../styles/homepage.css";

/*
<img src="/images/ix-trader.png" alt="IX Trader Show logo" />
*/

const featuredItems = [
  { name: "IX Trader Show", url: "https://www.blog.fintorro.com/fxstreet-premium-fintorro-pro-combo-bundle/" },
  { name: "London Trader Show", url: "https://www.blog.fintorro.com/london-investor-show-2024/" },
  { name: "UK Investor Show", url: "https://www.blog.fintorro.com/uk-investor-show/" },
  { name: "Traders Day Live", url: "https://www.blog.fintorro.com/traders-day-live-2023/" },
  { name: "Prop Funding Show", url: "https://www.blog.fintorro.com/what-is-the-london-prop-trading-expo-2025/" },
];

const FeaturedIn = () => {
  return (
    <section className="featured-in">
      <div className="container">
        <h2>Trusted By The  Community</h2>
        <div className="featured-pill-links">
          {featuredItems.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="featured-pill"
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedIn;




// // FeaturedIn
// import React from "react";
// import "../styles/homepage.css";

// const FeaturedIn = () => {
//   const logos = [
//     "IX Trader Show",
//     "London Trader Show",
//     "UK Investor Show",
//     "Traders Day Live",
//     "Prop Funding Show"
//   ];

//   return (
//     <section className="featured-in">
//       <div className="container">
//         <h2>Trusted By The Community</h2>
//         <div className="featured-logos">
//           {logos.map((logo, index) => (
//             <span key={index} className="logo-placeholder">{logo}</span>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FeaturedIn;
